import { Button } from "@/components/ui/button";
import { BarChart3, Eye, ArrowRight } from "lucide-react";
import dashboardMockup from "@/assets/dashboard-real.jpg";

const Dashboard = () => {
  return (
    <section className="py-16 px-4 sm:px-6">
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-12">
          <div className="inline-flex flex-col sm:flex-row items-center gap-3 mb-6">
            <Eye className="h-10 w-10 text-primary" />
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold">
              Visibilidad y <span className="text-primary">Control Total</span>
            </h2>
          </div>
          <p className="text-lg sm:text-xl text-muted-foreground max-w-3xl mx-auto">
            Tu centro de mando operacional
          </p>
        </div>
        
        <div className="bg-card border border-border rounded-2xl overflow-hidden shadow-2xl">
          {/* Dashboard Image */}
          <div className="relative">
            <img
              src={dashboardMockup}
              alt="Dashboard ConversIA"
              className="w-full h-auto object-cover"
            />
          </div>
          
          {/* Content */}
          <div className="p-6 sm:p-8 lg:p-12 space-y-6">
            <div className="flex flex-col sm:flex-row items-start gap-4">
              <BarChart3 className="h-8 w-8 text-primary flex-shrink-0 mt-1" />
              <div className="space-y-4">
                <p className="text-base sm:text-lg text-foreground leading-relaxed">
                  Nuestro <span className="text-primary font-semibold">Dashboard</span> es el centro de mando de tu operación.
                  Una interfaz potente y visual que te da control total sobre cada interacción.
                </p>
                
                <div className="grid md:grid-cols-2 gap-6 pt-4">
                  <div className="space-y-2">
                    <h4 className="font-semibold text-success flex items-center gap-2 text-base sm:text-lg">
                      <div className="w-2 h-2 rounded-full bg-success" />
                      Monitoreo en Tiempo Real
                    </h4>
                    <p className="text-sm sm:text-base text-muted-foreground pl-4">
                      Analiza conversaciones, tiempos de respuesta y desempeño de la IA con paneles intuitivos.
                    </p>
                  </div>
                  
                  <div className="space-y-2">
                    <h4 className="font-semibold text-urgent flex items-center gap-2 text-base sm:text-lg">
                      <div className="w-2 h-2 rounded-full bg-urgent" />
                      Intervención Instantánea
                    </h4>
                    <p className="text-sm sm:text-base text-muted-foreground pl-4">
                      Ante conversaciones críticas, un operador puede tomar el control del chat con un clic.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* <div className="pt-4">
              <Button variant="cta" size="lg">
                Explorar el Dashboard
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Dashboard;
